export const ProductsTableColumns = [
    { id: 'product', labelEn: 'Product', labelAr: 'المنتج', align: 'start' },
    { id: 'sku', labelEn: 'SKU', labelAr: 'SKU', align: 'start' },
    { id: 'category', labelEn: 'Category', labelAr: 'التصنيف', align: 'start' },
    { id: 'brand', labelEn: 'Brand', labelAr: 'البراند', align: 'start' },
    { id: 'price', labelEn: 'Price', labelAr: 'السعر', align: 'start' },
    { id: 'status', labelEn: 'Status', labelAr: 'الحالة', align: 'center' },
    { id: 'created_at', labelEn: 'Created At', labelAr: 'تاريخ الإضافة', align: 'start' },
];
